import React from 'react';

import { Icon, Wrapper } from './styles';

interface Props {
    percent?: number;
    number?: number;
    direction?: 'up' | 'down';
}

export const DiffValue = ({ percent, number, direction }: Props) => {
    if (!percent && !number) return null;

    return (
        <Wrapper $direction={direction}>
            <Icon $direction={direction} />
            {percent || number}
            {percent && '%'}
        </Wrapper>
    );
};
